import getYouTubeID from 'get-youtube-id';

const getYoutubeThumb = youtubeUrl => {
	const id = getYouTubeID(youtubeUrl);
	const thumbUrl = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
	return thumbUrl;
};

export default getYoutubeThumb;
